import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Checkout.OrderSummary.title',
    description: 'Order Summary title',
    defaultMessage: 'Order Summary',
  },
  itemsCount: {
    id: 'Checkout.OrderSummary.ItemsCount',
    description: 'Items count label',
    defaultMessage: `{items, plural,
      one {1 item}
      other {{items} items}
    }`,
  },
  quantity: {
    id: 'Checkout.OrderSummary.quantity',
    description: 'Quantity label',
    defaultMessage: 'Qty: {quantity}',
  },
  warrantyTerm: {
    id: 'Checkout.OrderSummary.warrantyTerm',
    defaultMessage: `{count, plural,
      one {Term: 1 Year}
      other {Term: {count} Years}
    }`,
  },
  warrantyProduct: {
    id: 'Checkout.OrderSummary.warrantyProduct',
    defaultMessage: 'Product: {product}',
  },
});
